/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const fantom_chain_about = () => `Fantom is a high-performance, scalable, and secure smart contract platform engineered to surpass the constraints of preceding blockchain platforms. Operating as a permissionless, decentralized, and open-source network, Fantom leverages Lachesis, its asynchronous Byzantine Fault Tolerance (aBFT) consensus mechanism. This innovative approach enables Fantom to achieve remarkable speed and affordability compared to older technologies while maintaining exceptional security standards.`
